import { IMG } from "../content";
import { Reveal } from "./Reveal";

const People = () => (
  <section className="people section-pad" data-testid="people-section">
    <div className="people-inner">
      <Reveal className="section-head-center">
        <p className="eyebrow eyebrow-light" data-testid="people-eyebrow">The whole athlete</p>
        <h2 className="section-heading section-heading-light">The People Behind Mindful Athlete</h2>
      </Reveal>
      <Reveal delay={0.15} className="people-photo">
        <img src={IMG.coachesCandid} alt="Agnieszka and Nika sitting outside together, reviewing session notes" loading="lazy" />
      </Reveal>
      <Reveal delay={0.25} className="people-copy">
        <p className="statement statement-light">Two coaches. <em>One whole-athlete approach.</em></p>
        <p className="body-copy body-copy-light">
          Agnieszka focuses on mindset and mental performance. Nika focuses on mobility, recovery, breathwork and
          nervous-system regulation. Together, the approach supports the whole athlete — performance, personal
          development and well-being.
        </p>
      </Reveal>
    </div>
  </section>
);

export default People;
